module.exports = __webpack_public_path__ + "img/auto-generated.b4dcb8be.png";